import { baseApi } from "./base.api";

export const dashboardApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        fetchDataCount: build.query({
            query: (params) => ({ url: "/dashboard/data/count", method: "GET", params }),
            providesTags: ["Dashboard"],
        }),
        fetchRecentPatients: build.query({
            query: (params) => ({ url: "/dashboard/recent/patients", method: "GET", params }),
            providesTags: ["Dashboard"],
        }),
        fetchRecentVisits: build.query({
            query: (params) => ({ url: "/dashboard/recent/visits", method: "GET", params }),
            providesTags: ["Dashboard"],
        }),
        fetchRecentVisits: build.query({
            query: (params) => ({ url: "/dashboard/recent/visits", method: "GET", params }),
            providesTags: ["Dashboard"],
        }),
        fetchUnitChartGraph: build.query({
            query: (params) => ({ url: "/dashboard/unit/chart", method: "GET", params }),
            providesTags: ["Dashboard"],
        }),
        fetchGenderGraph: build.query({
            query: (params) => ({
                url: "/dashboard/gender-vise/graph",
                method: "GET",
                params
            }),
            keepUnusedDataFor: 0,
            providesTags: ["Dashboard"],
        }),

        fetchVisitChart: build.query({
            query: (params) => ({
                url: "/dashboard/visit/chart",
                method: "GET",
                params
            }),
            keepUnusedDataFor: 0,
            providesTags: ["Dashboard"],
        }),
    }),
});

export const {
    useFetchDataCountQuery,
    useFetchRecentPatientsQuery,
    useFetchRecentVisitsQuery,
    useFetchGenderGraphQuery,
    useFetchVisitChartQuery,
    useFetchUnitChartGraphQuery,
} = dashboardApi;
